import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="React TODO Applicaton" link="https://github.com/KukR1/React-TODO-Form" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This is a TODO Applicaton built with React.js, using Hooks.
    </ProjectCard>
    <ProjectCard title="Form Validation Application" link="https://github.com/KukR1/react-form-v-app" bg="linear-gradient(to right, #7b22ba 10%, #2271ba 100%)" mdxType="ProjectCard">
  This is a Form Validation built with React.js, using Hooks.
    </ProjectCard>
    <ProjectCard title="API Cryptocurrency Application" link="https://github.com/KukR1/API-Cryptocurrency" bg="linear-gradient(to right, #135cc2 10%, #22c7b6 100%)" mdxType="ProjectCard">
  An API-Cryptocurrency application built with React.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      